import { LegalFile, ReplaceLegalFile, UpdateLegalFile } from "records/brand/brand";
import { defaultCheckError, progressEpic } from "./../base-epic";
import { BRAND } from "constants/action-types";
import siteConfig from "site-config";
import { add as snackbarAdd } from "actions/snackbars";
import { format } from "lib/globalize-util";
import { fetchLegalFiles } from "actions/brand";

export const fetchOrderLegalFilesEpic = progressEpic<void, any>(
    BRAND.LEGAL_FILES.FETCH,
    () => ({
        method: "GET",
        url: `${siteConfig.api}/brand/orders/orderlegalfiles`,
    }),
    { checkErrorStatus: defaultCheckError },
);

export const addOrderLegalFilesEpic = progressEpic<Partial<LegalFile>[], any>(
    BRAND.LEGAL_FILES.ADD,
    ({ payload }) => ({
        method: "POST",
        body: payload,
        url: `${siteConfig.api}/brand/orders/orderlegalfiles`,
    }),
    {
        checkErrorStatus: defaultCheckError,
        finishActions: (_, { payload }) => [
            snackbarAdd({ message: format("Successfully uploaded |n| file(s).", { n: payload.length }) }),
            fetchLegalFiles(),
        ],
    },
);

export const deleteOrderLegalFileEpic = progressEpic<Partial<LegalFile>[], any>(
    BRAND.LEGAL_FILES.DELETE,
    ({ payload }) => ({
        method: "DELETE",
        body: { ids: payload },
        url: `${siteConfig.api}/brand/orders/orderlegalfiles`,
    }),
    {
        checkErrorStatus: defaultCheckError,
        finishActions: (_, { payload }) => [
            snackbarAdd({ message: format("Successfully deleted |n| file(s).", { n: payload.length }) }),
            fetchLegalFiles(),
        ],
    },
);

export const replaceOrderLegalFileEpic = progressEpic<ReplaceLegalFile, any>(
    BRAND.LEGAL_FILES.REPLACE,
    ({ payload }) => ({
        method: "POST",
        body: payload,
        url: `${siteConfig.api}/brand/orders/orderlegalfiles/replace`,
    }),
    {
        checkErrorStatus: defaultCheckError,
        finishActions: () => [
            snackbarAdd({ message: format("Successfully uploaded |n| file(s).", { n: 1 }) }),
            fetchLegalFiles(),
        ],
    },
);

export const updateOrderLegalFileEpic = progressEpic<UpdateLegalFile, any>(
    BRAND.LEGAL_FILES.UPDATE,
    ({ payload }) => ({
        method: "PATCH",
        body: payload,
        url: `${siteConfig.api}/brand/orders/orderlegalfiles`,
    }),
    {
        checkErrorStatus: defaultCheckError,
        finishActions: () => [snackbarAdd({ message: format("Successfully updated the file.") }), fetchLegalFiles()],
    },
);
